import { useEffect, useRef } from "react";

export default function useTimeout(callback: Function, delay: null | number) {
    const savedCallback = useRef<null | Function>(null);
    const timeoutId = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            if (savedCallback.current !== null) {
                savedCallback.current();
            }
        }

        if (delay !== null) {
            timeoutId.current = setTimeout(tick, delay);
            return () => {
                if (timeoutId.current) {
                    clearTimeout(timeoutId.current);
                }
            };
        }
    }, [delay]);
}
